import { useEffect, useState } from 'react';

/**
 * False once the page has been hidden for `graceMs`, true again as soon as it
 * is visible. Live tiles use it to release camera ingests in background tabs
 * without reconnecting on a quick tab switch.
 */
export function usePageVisible(graceMs = 15_000): boolean {
  const [visible, setVisible] = useState(() => document.visibilityState !== 'hidden');
  useEffect(() => {
    let timer: number | undefined;
    const onChange = () => {
      window.clearTimeout(timer);
      if (document.visibilityState === 'hidden') {
        timer = window.setTimeout(() => {
          setVisible(false);
        }, graceMs);
      } else {
        setVisible(true);
      }
    };
    document.addEventListener('visibilitychange', onChange);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', onChange);
    };
  }, [graceMs]);
  return visible;
}
